//SelectIdTitleNodeDialog
//***********************************************************************************************************************
import { Box } from "@mui/material";
import * as React from "react";
import { TreeCheckBoxDropdownItems } from "ui/Scripts/source/components/framework/Dropdown/TreeCheckboxDropdown/TreeCheckboxDropdownItems";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "../../../framework/Dialog/Dialog";

//SelectIdTitleNodesDialog
export interface ISelectIdTitleNodesDialogProps {
    classes?: string;
    required?: boolean;
    singleSelect?: boolean;
    toggleAllId?: string;
    nodes: IIdTitleNode[];
    title: string;
    selectedIds: string[];
    onOk: (selectedIds: string[]) => void;
    onCancel: () => void;
}

export interface ISelectIdTitleNodesDialogState {
    selectedIds: string[];
}

export class SelectIdTitleNodesDialog extends React.Component<ISelectIdTitleNodesDialogProps, ISelectIdTitleNodesDialogState> {
    constructor(props: ISelectIdTitleNodesDialogProps) {
        super(props);
        this.state = {
            selectedIds: props.selectedIds ?? []
        };
    }

    handleOk = () => {
        const props = this.props;
        const state = this.state;
        if (props.required && state.selectedIds.length < 1) return;
        props.onOk(state.selectedIds);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                id="select-id-title-node-dialog"
                maxWidth="sm"
                title={props.title}
                body={
                    <Box sx={{ margin: "0 -1rem" }}>
                        <TreeCheckBoxDropdownItems
                            selectedIds={state.selectedIds}
                            singleSelect={props.singleSelect}
                            toggleAllId={props.toggleAllId}
                            values={props.nodes}
                            onChange={selectedIds => this.setState({ selectedIds })}
                        />
                    </Box>
                }
                buttons={[
                    { title: Translations.Cancel, variant: "outlined", onClick: props.onCancel },
                    { title: Translations.OK, variant: "confirmation", onClick: this.handleOk, disabled: props.required && state.selectedIds.length < 1 },
                ]}
                onClose={props.onCancel}
            />
        );
    }
}